// ARCHIVO: src/main.jsx
// UBICACIÓN: C:\xampp\htdocs\react-migration\src\main.jsx
// DESCRIPCIÓN: Punto de entrada principal de la aplicación React

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './styles/index.css'
import './utils/comercioInit.js'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter basename="/sf3/ventas">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)